// extracted by mini-css-extract-plugin
export var cardTitle = "_id-1";
export var commentBubble = "_id-e";
export var commentForm = "_id-a";
export var commentInput = "_id-b";
export var commentLabel = "_id-d";
export var commentPrompt = "_id-9";
export var csatCard = "_id-0";
export var feedbackSection = "_id-7";
export var starDisabled = "_id-6";
export var starEmpty = "_id-5";
export var starFilled = "_id-4";
export var starWrapper = "_id-3";
export var starsContainer = "_id-2";
export var submittedComment = "_id-c";
export var thankYouText = "_id-8";